import React from 'react';
import { getTestimonials } from '../../data/companyDetails';

const Testimonial = () => {
  const testimonials = getTestimonials();

  // Helper function to render star rating
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i 
          key={i} 
          className={`fas fa-star ${i <= rating ? 'text-warning' : 'text-muted'}`}
        ></i>
      );
    }
    return stars;
  };

  return (
    <section className="py-5 bg-primary" id="testimonials">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center mb-5">
            <span className="badge bg-white bg-opacity-20 text-black px-3 py-2 rounded-pill mb-3">
              💬 Testimonials
            </span>
            <h2 className="display-5 fw-bold mb-4 text-white">What Our Users Say</h2>
            <p className="lead text-white opacity-90">
              Real Reviews. Real Love. Thousands of creators and viewers are making MastiShorts their go-to platform for live streaming and short videos. Here's what some of them have to say:
            </p>
          </div>
        </div>
        
        <div className="row g-4">
          {testimonials.slice(0, 3).map((testimonial) => (
            <div key={testimonial.id} className="col-lg-4 col-md-6">
              <div className="card h-100 border-0 bg-white shadow-lg rounded-4 overflow-hidden position-relative hover-lift">
                <div className="position-absolute top-0 end-0 bg-primary text-white rounded-bottom-start p-2">
                  <i className="fas fa-quote-right fa-lg"></i>
                </div>
                
                <div className="card-body p-4">
                  <div className="mb-4">
                    {renderStars(testimonial.rating)}
                  </div>
                  
                  <blockquote className="mb-4">
                    <p className="fst-italic text-muted">
                      "{testimonial.review}"
                    </p>
                  </blockquote>
                  
                  <div className="d-flex align-items-center">
                    <div className="bg-primary bg-gradient text-white rounded-circle d-inline-flex align-items-center justify-content-center me-3 shadow" style={{width: '50px', height: '50px'}}>
                      <i className={`${testimonial.icon} fa-lg`}></i>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1 text-dark">{testimonial.name}</h6>
                      <small className="text-muted">{testimonial.date}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {testimonials.length > 3 && (
          <>
            <div className="row g-4 mt-2">
              {testimonials.slice(3, 6).map((testimonial) => (
                <div key={testimonial.id} className="col-lg-4 col-md-6">
                  <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden position-relative hover-lift">
                    <div className="position-absolute top-0 end-0 bg-primary text-white rounded-bottom-start p-2">
                      <i className="fas fa-quote-right fa-lg"></i>
                    </div>
                    
                    <div className="card-body p-4">
                      <div className="mb-4">
                        {renderStars(testimonial.rating)}
                      </div>
                      
                      <blockquote className="mb-4">
                        <p className="fst-italic text-muted">
                          "{testimonial.review}"
                        </p>
                      </blockquote>
                      
                      <div className="d-flex align-items-center">
                        <div className="bg-primary bg-gradient text-white rounded-circle d-inline-flex align-items-center justify-content-center me-3 shadow" style={{width: '50px', height: '50px'}}>
                          <i className={`${testimonial.icon} fa-lg`}></i>
                        </div>
                        <div>
                          <h6 className="fw-bold mb-1">{testimonial.name}</h6>
                          <small className="text-muted">{testimonial.date}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        
        <div className="row mt-5">
          <div className="col-lg-12 text-center">
            <div className="bg-white text-dark rounded-4 p-4 shadow-lg">
              <h4 className="fw-bold mb-3 text-primary">
                <i className="fas fa-users me-2"></i>
                Join Thousands of Happy Users!
              </h4>
              <p className="mb-4 text-muted">
                Experience the joy of live streaming and short video creation with MastiShorts
              </p>
              <button className="btn btn-primary btn-lg px-5 py-3 rounded-pill fw-bold shadow">
                <i className="fas fa-download me-2"></i>
                Get Started Today
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
